import Vue from 'vue';
import Vuex from 'vuex';
import { BaseStore } from '@discoveryeducation/core';
import GameModule from './game.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { ...BaseStore, GameModule },
});
